import styled from "styled-components";

const PageLinkDiv = styled.div`
  color: #757575;
  font-size: 16px;
`;
export default PageLinkDiv;
